var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"name-parts",attrs:{"title":_vm.name}},[_c('NcHighlight',{staticClass:"name-parts__first",attrs:{"text":_vm.part1,"search":_vm.search,"highlight":_vm.highlight1}}),_vm._v(" "),(_vm.part2)?_c('NcHighlight',{staticClass:"name-parts__last",attrs:{"text":_vm.part2,"search":_vm.search,"highlight":_vm.highlight2}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }